import { Component, OnInit, HostBinding, Output, EventEmitter, Input, ViewChild, TemplateRef, Optional, ChangeDetectorRef, Inject, LOCALE_ID } from '@angular/core';
import { TypeConverter } from '@farris/ide-property-panel';
import { FormBuilder } from '@angular/forms';
import { SignRuleEntity } from './entites/sign-rule.entity';
import { DialogComponent } from '@farris/ui-dialog';
import { ExprEditMode, ExpressionService, VarEntity } from '@gsp-svc/expression';
import { MessagerService } from '@farris/ui-messager';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { ProcessDeUtil } from '../../domain/process-de-util';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { of } from 'rxjs';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';
import { BpmnModel, BpmnModelHelper } from '@edp-pmf/bpmn-model';
import { Condition, CounterSignRule } from '@gsp-wf/wf-process-model';

@Component({
  selector: 'app-sign-rule',
  templateUrl: './sign-rule.component.html',
  styleUrls: ['./sign-rule.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class SignRuleComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';
  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();


  //会签规则打开页面
  @Input()
  set value(rules: any[]) {
    if (rules && rules.length > 0) {
      for (const rule of rules) {
        const val = new SignRuleEntity();
        val.id = ProcessDeUtil.GenerateElementId();
        val.conclusionValue = rule.ConclusionValue;
        val.conclusionName = rule.ConclusionName;
        val.calculateType = rule.CalculateType ? rule.CalculateType : 'null';
        val.conditionValue = rule.ConditionValue ? rule.ConditionValue : 0;
        val.waitAllVotes = rule.WaitAllVotes ? rule.WaitAllVotes : false;
        val.completionCondition = rule.CompletionCondition ? rule.CompletionCondition._value : null;
        this.data.push(val);
      }
    } else { // 如果模型上没有会签规则，自动带入所有的审批选项
      this.deleteRow();
    }
  }

  //多实例打开完成规则页面
  @Input()
  set value1(rules: any[]) {
    this.editCondition = true;
    if (rules && rules.length > 0) {
      for (const rule of rules) {
        const val = new SignRuleEntity();
        val.id = BpmnModelHelper.GenerateElementId();
        val.conclusionValue = rule.ConclusionValue;
        // val.conclusionName = rule.conclusionName;
        val.calculateType = rule.CalculateType ? rule.CalculateType : 'null';
        val.conditionValue = rule.ConditionValue ? rule.ConditionValue : 0;
        val.waitAllVotes = rule.WaitAllVotes ? rule.WaitAllVotes : false;
        val.completionCondition = rule.CompletionCondition ? rule.CompletionCondition.Value : null;
        this.data.push(val);
      }
      this.data = this.setName1(this.data);
    } else { // 如果模型上没有会签规则，自动带入所有的审批选项
      this.deleteRow1();
    }
  }
  @Input() editorParams: any = {};
  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;
  @ViewChild('iconSelectFooter1') modalFooter1: TemplateRef<any>;
  @ViewChild('approvalTable') apvlItemsGrid: DatagridComponent;
  @ViewChild('approvalItemDialog') apvlItemDialog: DialogComponent;
  @ViewChild('grid') grid: DatagridComponent;

  modalConfig = {
    title: this.localePipe.transform('component.signRule.countersignRules'),
    width: 800,
    height: 520,
    showButtons: true
  };
  editCondition: boolean = false;
  data: SignRuleEntity[] = [];
  calculationMethods: any[] = [
    { text: this.localePipe.transform('component.signRule.byNumber'), value: 'byNumber' },
    { text: this.localePipe.transform('component.signRule.byProportion'), value: 'byProportion' },
    { text: this.localePipe.transform('component.signRule.customConditions'), value: 'null' },
  ];
  counterSignVariables: VarEntity[] = [];

  bpmnModel: BpmnModel = this.designerUIState.bpmnModel;
  /******* 审批项帮助参数 *********************************************************/
  approvalCols = [{ title: this.localePipe.transform('component.signRule.value'), field: 'value', width: 80 },
  { title: this.localePipe.transform('component.signRule.text'), field: 'text', width: 90 }];
  approvalItems: any[] = [];

  approvalItems1: any[] = [
    { value: 'Forward',  text: this.localePipe.transform('multiInstanceLoopCharacteristics.completionConditionRulesList.forward') },
    { value: 'Backward', text: this.localePipe.transform('multiInstanceLoopCharacteristics.completionConditionRulesList.backward') },
    { value: 'Abort',  text: this.localePipe.transform('multiInstanceLoopCharacteristics.completionConditionRulesList.abort') }
  ];
/*********************************** */
  columns = [
    { field: 'conclusionName', width: 25, title: this.localePipe.transform('component.signRule.conclusionName') },
    { field: 'conclusionValue', width: 25, title: this.localePipe.transform('component.signRule.conclusionValue') },
    { field: 'calculateType', width: 40, title: this.localePipe.transform('component.signRule.calculateType'),
      formatter: {type: 'enum',options: { valueField: 'value', textField: 'text', data: this.calculationMethods }},
      editor: {type: EditorTypes.COMBOLIST,options: { valueField: 'value', textField: 'text', data: this.calculationMethods, idField: 'value', panelHeight: 'auto' }}
    },
    { field: 'conditionValue', width: 25, title: this.localePipe.transform('component.signRule.conditionValue'),
      editor: { type: EditorTypes.NUMBERBOX, options: {} },
      formatter:{type: 'number', options: { precision: 0, min: 0 } }
    },
    { field: 'waitAllVotes', width: 35, title: this.localePipe.transform('component.signRule.waitAllVotes'),
      editor: { type: EditorTypes.SWITCH, options: {} },
      formatter: { type: 'boolean', options: { trueText: this.localePipe.transform('component.signRule.yes'), falseText: this.localePipe.transform('component.signRule.no') }}
    },
    { field: 'completionCondition', width: 50, title: this.localePipe.transform('component.signRule.customConditions'),
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.editConditon(e);
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      }
    }
  ];

  constructor(
    private formBuilder: FormBuilder,
    private message: MessagerService,
    private exprService: ExpressionService,
    private designerUIState: ProcessDesignerUIState,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
    this.counterSignVariables = this.designerUIState.counterSignVariables || [];
    this.approvalItems = this.designerUIState.approvalItems || [];
  }
  // 重置动作
  deleteRow() {
    this.data = [];
    const ruleItems = this.designerUIState.approvalItems || [];
    if (ruleItems && ruleItems.length > 0) {
      for (const ruleItem of ruleItems) {
        const val = new SignRuleEntity();
        if (ruleItem.value === 'Pass') {
          val.id = ProcessDeUtil.GenerateElementId();
          val.conclusionValue = ruleItem.value;
          val.conclusionName = ruleItem.text;
          val.calculateType = 'byProportion';
          val.conditionValue = '100';
          val.waitAllVotes = true;
        } else if (ruleItem.value === 'Back') {
          val.id = ProcessDeUtil.GenerateElementId();
          val.conclusionValue = ruleItem.value;
          val.conclusionName = ruleItem.text;
          val.calculateType = 'byNumber';
          val.conditionValue = '1';
          val.waitAllVotes = true;
        } else {
          val.id = ProcessDeUtil.GenerateElementId();
          val.conclusionValue = ruleItem.value;
          val.conclusionName = ruleItem.text;
          val.calculateType = 'null';
          val.conditionValue = '0';
          val.waitAllVotes = true;
        }
        this.data.push(val);
      }
    }
  }

    // 重置动作
    deleteRow1() {
      this.data = [];
      if (this.approvalItems1 && this.approvalItems1.length > 0) {
        for (const ruleItem of this.approvalItems1) {
          const val = new SignRuleEntity();
          if (ruleItem.value === 'Forward') {
            val.id = ProcessDeUtil.GenerateElementId();
            val.conclusionValue = ruleItem.value;
            val.conclusionName = ruleItem.text;
            val.calculateType = 'byProportion';
            val.conditionValue = '100';
            val.waitAllVotes = true;
          } else if (ruleItem.value === 'Backward' || ruleItem.value === 'Abort') {
            val.id = ProcessDeUtil.GenerateElementId();
            val.conclusionValue = ruleItem.value;
            val.conclusionName = ruleItem.text;
            val.calculateType = 'byNumber';
            val.conditionValue = '1';
            val.waitAllVotes = true;
          } else {
            val.id = ProcessDeUtil.GenerateElementId();
            val.conclusionValue = ruleItem.value;
            val.conclusionName = ruleItem.text;
            val.calculateType = 'null';
            val.conditionValue = '0';
            val.waitAllVotes = true;
          }
          this.data.push(val);
        }
      }
    }

     // 给个名字
     setName1(signRuleEntity:SignRuleEntity[]) {
      if (signRuleEntity && signRuleEntity.length > 0) {
        for (var i = 0; i < signRuleEntity.length;i++) {
          if (signRuleEntity[i].conclusionValue === 'Forward') {
            signRuleEntity[i].conclusionName = this.localePipe.transform('multiInstanceLoopCharacteristics.completionConditionRulesList.forward');
          } else if (signRuleEntity[i].conclusionValue === 'Backward') {
            signRuleEntity[i].conclusionName = this.localePipe.transform('multiInstanceLoopCharacteristics.completionConditionRulesList.backward');
          } else if (signRuleEntity[i].conclusionValue === 'Abort'){
            signRuleEntity[i].conclusionName = this.localePipe.transform('multiInstanceLoopCharacteristics.completionConditionRulesList.abort');
          }
        }
      }
      return signRuleEntity;
    }

  clickOK() {
    this.grid.endCellEdit();
    if (this.data.length === 0) {
      this.message.warning(this.localePipe.transform('component.signRule.notEmpty'));
    } else if(this.validate(this.data)) {
      this.message.warning(this.localePipe.transform('component.signRule.conditionNotEmpty'));
    } else {
      const object = { value: this.data, parameters: null };
      this.submitModal.emit(object);
    }
  }

  clickOK1() {
    this.grid.endCellEdit();
    if (this.data.length === 0) {
      this.message.warning(this.localePipe.transform('component.signRule.notEmpty'));
    } else if(this.validate(this.data)) {
      this.message.warning(this.localePipe.transform('component.signRule.conditionNotEmpty'));
    } else {
      let counterSignRules = new Array<CounterSignRule>();
      this.data.forEach(d => {
        let counterSignRule = new CounterSignRule(this.bpmnModel);
        counterSignRule.CalculateType = d.calculateType;
        counterSignRule.ConclusionValue = d.conclusionValue;
        counterSignRule.ConditionValue = d.conditionValue
        counterSignRule.WaitAllVotes = d.waitAllVotes;
        counterSignRule.CompletionCondition = new Condition(this.bpmnModel);
        counterSignRule.CompletionCondition.Value = d.completionCondition;
        counterSignRules.push(counterSignRule);
      })
      // let counterSignRules = new CounterSignRule(this.bpmnModel);

      this.submitModal.emit(counterSignRules);
    }
  }

  clickCancel() {
    this.closeModal.emit();
  }

  validate(data: SignRuleEntity[]) {
    //表示是否需要校验
    let flag:boolean = false;
    if(data && data.length > 0) {
      data.forEach(d => {
        if(d.calculateType == 'null' && !d.completionCondition) {
          //如果存在某一行，设置了自定义条件，但是没有在后面设置条件，那需要进行提示
          flag = true;
        }
      })
    }
    
    return flag;
  }

  editConditon(e: any) {
    // this.exprService.clearContext();
    const context = new Array();
    if(this.editCondition) {
      if (this.designerUIState.multiCounterSignVariables.length > 0) {
        for (const variable of this.designerUIState.multiCounterSignVariables) {
          if (!context.some(c => c.key === variable.key)) {
            context.push(variable);
          }
        }
      }
      if (context.length > 0) {
        for (const v of context) {
          this.exprService.addContext(v);
        }
      }
    }else {
      if (this.counterSignVariables && this.counterSignVariables.length > 0) {
        for (const variable of this.counterSignVariables) {
          if (!context.some(c => c.key === variable.key)) {
            context.push(variable);
          }
        }
      }
      if (this.designerUIState.subActivityContext.length > 0) {
        for (const variable of this.designerUIState.subActivityContext) {
          if (!context.some(c => c.key === variable.key)) {
            context.push(variable);
          }
        }
      }
      if (context.length > 0) {
        for (const v of context) {
          this.exprService.addContext(v);
        }
      }
    }    
    this.exprService.setEditPattern(ExprEditMode.Advanced); // 表达式展现模式：默认高级版（会签规则需要上下文变量）
    this.exprService.addExpressionText(e.instance.value);
    this.exprService.buildExpression().then((cond: string) => {
      e.formControl.setValue(cond);
      e.instance.cd.detectChanges();
      //点击确定后，去除表达式里面的新增的上下文变量
      if(context.length > 0) {
        this.exprService.exprEntity.contextEntities = this.exprService.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
      }
    });
  }

  /**
   * 选中审批项
   */
  approvalSelect() {
    const selections: any[] = this.apvlItemsGrid.checkeds;
    if (selections && selections.length > 0) {
      for (const selection of selections) {
        const signRule = new SignRuleEntity();
        signRule.id = ProcessDeUtil.GenerateElementId();
        signRule.conclusionValue = selection.data.value;
        signRule.conclusionName = selection.data.text;
        this.data.push(signRule);
      }
      this.grid.loadData(this.data);
      this.apvlItemDialog.close();
    } else {
      this.message.info(this.localePipe.transform('component.signRule.pleaseSelect'));
    }
  }


  preValue: SignRuleEntity;
  curValue: SignRuleEntity;
/**
 * 结束编辑前事件
 */
  afterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    this.preValue = JSON.parse(JSON.stringify(rowData));
    return of(true);
  }

  endEdit(e: any) {
    this.curValue = e.rowData;
    // 自定义会签规则和预置会签规则互斥
    if(this.preValue.completionCondition !== this.curValue.completionCondition && 
      !(this.isEmpty(this.preValue.completionCondition) && this.isEmpty(this.curValue.completionCondition))) {
      this.data[e.rowIndex].calculateType = 'null',
      this.data[e.rowIndex].conditionValue = '0';
      this.data[e.rowIndex].waitAllVotes = false;
    } else if (this.preValue.calculateType !== this.curValue.calculateType ||
      this.preValue.conditionValue !== this.curValue.conditionValue ||
      this.preValue.waitAllVotes !== this.curValue.waitAllVotes) {
        this.data[e.rowIndex].completionCondition = null;
    }

    if(e.column.field === 'conditionValue' && this.data[e.rowIndex].calculateType === 'byProportion'
    && Number.parseInt(e.value) > 100) {
      this.message.info(this.localePipe.transform('component.signRule.maxConditionValue'));
      this.data[e.rowIndex].conditionValue = '100';
    } else if (e.column.field === 'conditionValue' && Number.parseInt(e.value) < 0) {
      this.message.info(this.localePipe.transform('component.signRule.minConditionValue'));
      this.data[e.rowIndex].conditionValue = '0';
    } else if ((e.column.field === 'calculateType' || e.column.field === 'conditionValue') && (this.data[e.rowIndex].calculateType === 'oneVote' ||
    this.data[e.rowIndex].calculateType === 'fullVote') && Number.parseInt(this.data[e.rowIndex].conditionValue) !== 0) {
      this.message.info(this.localePipe.transform('component.signRule.noConditional'));
      this.data[e.rowIndex].conditionValue = '0';
    } else if (e.column.field === 'calculateType' && this.data[e.rowIndex].calculateType === 'byProportion' &&
    Number.parseInt(this.data[e.rowIndex].conditionValue) > 100) {
      this.message.info(this.localePipe.transform('component.signRule.maxConditionValue'));
      this.data[e.rowIndex].conditionValue = '100';
      }
  }

  isEmpty(s: string) {
    if(!s || s.length == 0) {
      return true;
    }else {
      return false;
    }
  }

}

export class SignRuleConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: any[]): string {
    // 会签规则只要启用就有默认值，所以始终置为'已设置';
    if(data && data.length > 0) {
      return this.localePipe.transform("component.signRule.set");
    }else {
      return this.localePipe.transform("component.signRule.notSet");
    }
  }
}
